import { render, staticRenderFns } from "./GuaEdit.vue?vue&type=template&id=72fae933"
import script from "./GuaEdit.vue?vue&type=script&lang=js"
export * from "./GuaEdit.vue?vue&type=script&lang=js"
import style0 from "./GuaEdit.vue?vue&type=style&index=0&id=72fae933&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports